module.exports = __webpack_public_path__ + "static/img/gm_open02.6ff542a2.png";